import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito equipo de gimnasio?',
  a: 'No. El protocolo incluye ejercicios que puedes hacer con tu propio peso corporal.'
}, {
  q: '¿Es muy difícil?',
  a: 'Es un desafío real. Está diseñado para ser incómodo, porque la comodidad no transforma a nadie.'
}, {
  q: '¿Qué pasa si fallo un día?',
  a: 'El manual incluye una guía táctica para levantarte y retomar el camino de inmediato.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-bg bg-noise" data-id="element-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} className="text-center mb-10 sm:mb-16" data-id="element-18">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-19">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-[1px] bg-dark-border mx-auto" data-id="element-20" />
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-21">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`border rounded-sm overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-dark-surface border-gold/50' : 'bg-dark-card border-dark-border hover:border-gray-700'}`} data-id="element-22">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left focus:outline-none gap-3" data-id="element-23">
                  <span className={`font-cinzel font-bold text-base sm:text-lg ${isOpen ? 'text-gold' : 'text-white'}`} data-id="element-24">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-4 h-4 sm:w-5 sm:h-5 shrink-0 transition-transform duration-300 ${isOpen ? 'text-gold rotate-180' : 'text-gray-500'}`} data-id="element-25" />
                </button>

                <AnimatePresence initial={false} data-id="element-26">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-27">
                      <div className="px-4 sm:px-6 pb-4 sm:pb-5 text-sm sm:text-base text-gray-400 leading-relaxed border-t border-dark-border/50 pt-3 sm:pt-4" data-id="element-28">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}